import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { storeRapport } from '../tools/fonctions'
import { titleColor, orGradient } from '../tools/colors'

import {
    collection,
    getDocs,
    query,
    where,
    deleteDoc,
    doc
} from 'firebase/firestore'
import { db } from '../config/fbConfig'

class MenuRapport extends Component {
    state = {
        rapport: []
    }

    async componentDidMount() {
        if (!window.localStorage.email) {
            this.props.history.push('/authentification')
            return
        }

        // Nettoyage du localStorage
        window.localStorage.removeItem('nomRapport')
        window.localStorage.removeItem('typeRapport')
        window.localStorage.removeItem('numRapport')

        if (window.localStorage.Autorisation === 'National') {
            window.localStorage.removeItem('Secteur')
            window.localStorage.removeItem('Agence')
        }

        if (window.localStorage.Autorisation === 'Secteur') {
            window.localStorage.removeItem('Agence')
        }

        window.localStorage.removeItem('dateDeb')
        window.localStorage.removeItem('dateFin')
        window.localStorage.removeItem('nomParamSecteur')
        window.localStorage.removeItem('nomParamAgence')
        window.localStorage.removeItem('dateParamFin')
        window.localStorage.removeItem('dateParamDeb')

        try {
            // 🔹 Suppression des GUID liés à l'utilisateur
            const guidQuery = query(
                collection(db, 'GUID'),
                where('email', '==', window.localStorage.email)
            )

            const guidSnapshot = await getDocs(guidQuery)

            for (const guidDoc of guidSnapshot.docs) {
                await deleteDoc(doc(db, 'GUID', guidDoc.id))
            }

            // 🔹 Récupération des rapports autorisés
            const autorisationQuery = query(
                collection(db, 'autorisations'),
                where('utilisateur', '==', window.localStorage.email)
            )

            const autorisationSnapshot = await getDocs(autorisationQuery)

            autorisationSnapshot.forEach(docSnap => {
                this.setState({
                    rapport: docSnap.data().Rapports || []
                })
            })
        } catch (error) {
            console.error('Erreur MenuRapport:', error)
        }
    }

    render() {
        const { rapport } = this.state

        return (
            <div
                className="container menu-rapport bg-white mt-4"
                style={{
                    border: 'solid',
                    borderWidth: '1px',
                    borderColor: titleColor
                }}
            >
                <h1 style={{ color: titleColor }}>Rapports</h1>

                <div className="d-flex flex-column">
                    <div className="card-columns">
                        {rapport.map(rapport => (
                            <div
                                className="card mb-2"
                                key={rapport.nomRapport}
                                style={{
                                    boxShadow:
                                        '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19)'
                                }}
                            >
                                <div className="card-body" style={orGradient}>
                                    <Link
                                        to="/rapport"
                                        className="h5"
                                        style={{ color: 'white' }}
                                        onClick={() =>
                                            storeRapport(
                                                rapport.nomRapport,
                                                rapport.typeRapport,
                                                rapport.numRapport,
                                                window.localStorage.Secteur,
                                                window.localStorage.Agence,
                                                null,
                                                null,
                                                rapport.nomParamSecteur,
                                                rapport.nomParamAgence,
                                                rapport.nomParamDateDeb,
                                                rapport.nomParamDateFin
                                            )
                                        }
                                    >
                                        {rapport.nomRapport}
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(MenuRapport)
